<script>
import { mapActions } from 'vuex'

export default {
  name: 'ResendClaimModal',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      progress: false,
    }
  },
  methods: {
    ...mapActions('claims', ['claimInvite']),
    async onSubmit() {
      this.progress = true

      const [error, request] = await this.claimInvite(this.id)

      if (!error) {
        this.$emit('done', request)
        this.$emit('close-modal')
      }

      this.progress = false
    },
  },
}
</script>

<template>
  <state-dialog
    title="Resend Registration Link"
    width="380px"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-icon
      slot="icon"
      name="link"
    />
    <el-icon
      slot="subicon"
      :class="$style.subicon"
      name="message"
    />
    <div :class="$style.msg">
      An email containing a personalised URL and login details will be sent to the member.
    </div>
    <div class="modal__footer">
      <el-button
        type="primary"
        :loading="progress"
        class="el-button--wide"
        @click.stop="onSubmit"
      >
        Send link
      </el-button>
    </div>
  </state-dialog>
</template>

<style lang="scss" module>
.msg {
  word-break: normal;
}

.subicon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  font-size: 18px;
  color: var(--color-primary-text);
  background-color: var(--color-primary);
  border-radius: 50%
}
</style>
